import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Contact = () => {

    return (
        <>
            <Header />
            <div>
                <div style={{ padding: '40px 20px', maxWidth: '1400px', margin: '0 auto', fontFamily: 'sans-serif', }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '20px', marginBottom: '40px', }}>
                        <div>
                            <h3>LET’S HAVE A CHAT!</h3>
                            <p>Mobile: +91 9885019299</p>
                        </div>
                        <div>
                            <h3>Glocart</h3>
                            <p>Shop No 6, 6-3-10/2, Balanagar,</p>
                            <p>Behind Vilamtheater, Hyderabad,</p>
                            <p>Telangana 500042 India</p>
                        </div>
                        <div>
                            <h3>EMAIL</h3>
                            <p><a href="mailto:onlinesales@shreenathfoods.com">onlinesales@shreenathfoods.com</a></p>
                        </div>
                    </div>

                    {/* Form Grid */}
                    <form style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', }}>
                        <div style={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', gap: '15px', }}>
                            <input type="text" placeholder="Your Name" style={{ padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px', }} />
                            <input type="email" placeholder="Your Email" style={{ padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px', }} />
                            <input type="tel" placeholder="Your Phone" style={{ padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px', }} />
                        </div>
                        <div style={{ flex: '1 1 45%', }}>
                            <textarea placeholder="Your Message" rows="4" style={{ width: '100%', height: '100%', padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px', resize: 'vertical', minHeight: '170px', }}></textarea>
                        </div>
                        <button type="submit" style={{ alignItems: 'center', marginTop: '20px', padding: '12px 24px', fontSize: '16px', backgroundColor: '#920e0e', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', }}>Send Message</button>
                    </form>


                    <div style={{ marginTop: '40px' }}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.9222868358165!2d78.44847117435835!3d17.463433283436792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90f2dcfd09a5%3A0xaa1cc50923de9aff!2sShreenath%20Foods!5e0!3m2!1sen!2sin!4v1745672487931!5m2!1sen!2sin" width="100%" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" ></iframe>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
